const styles = {
  tab: {
    paddingTop: 20,
    paddingLeft: 10,
    paddingRight: 10
  }
};

export default styles;
